<script lang="ts">
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  import { PersistedState } from 'runed';
  import Svg from '$src/js/modules/ui/components/Svg.svelte';
  import ActivityTags from '$src/js/modules/calendar/templates/components/ActivityTags.svelte';
  import FormField from '$src/js/modules/ui/components/form/FormField.svelte';
  import { CalendarService } from '$src/js/modules/calendar/services/CalendarService';
  import { CalendarStateFilter } from '$src/js/modules/calendar/state/calendarState.svelte';

  const calendarService = new CalendarService();

  let filterTags = new PersistedState<string[]>('r2r-filter-tags', [''], {
    storage: 'session',
  });
  let searchValue = new PersistedState<string>('r2r-filter-search', '', {
    storage: 'session',
  });
  let locationDisplay = new PersistedState<string>(
    'r2r-filter-location-display',
    '',
    {
      storage: 'session',
    }
  );
  let locationCoordinates = new PersistedState<[number, number] | []>(
    'r2r-filter-location-coordinates',
    [],
    {
      storage: 'session',
    }
  );
  let distanceValue = new PersistedState<string>(
    'r2r-filter-distance',
    Object.keys(calendarService.FILTER_DISTANCE_OPTIONS)[0],
    {
      storage: 'session',
    }
  );
  let dateObjects = new PersistedState<Date[]>('r2r-filter-date-objects', [], {
    storage: 'session',
  });

  let foldableButton = $state(true);
  let foldableOpen = $state(false);

  $effect(() => {
    CalendarStateFilter.tags = filterTags.current;
    CalendarStateFilter.search = '';
    CalendarStateFilter.locationDisplay = '';
    CalendarStateFilter.locationCoordinates = [];
    CalendarStateFilter.distance = '';
    CalendarStateFilter.dateObjects = [];

    if (searchValue.current) {
      CalendarStateFilter.search = searchValue.current;
    }

    if (locationDisplay.current) {
      CalendarStateFilter.locationDisplay = locationDisplay.current;
    }

    if (locationCoordinates.current.length) {
      CalendarStateFilter.locationCoordinates = locationCoordinates.current;
    }

    if (distanceValue.current) {
      CalendarStateFilter.distance = distanceValue.current;
    }

    if (dateObjects.current[0]) {
      CalendarStateFilter.dateObjects = [
        new Date(dateObjects.current[0]),
        new Date(dateObjects.current[1]),
      ];
    }

    calendarService.filter();
  });

  async function handleLocationBlur(event: Event) {
    const value = (event.target as HTMLInputElement).value;

    if (!value) {
      locationDisplay.current = '';
      locationCoordinates.current = [];
      return;
    }

    locationDisplay.current = value;
    locationCoordinates.current =
      await calendarService.getGeoLocationFromString(value);
  }

  const manageFold = () => {
    if (window.innerWidth >= 1024) {
      foldableButton = false;
      foldableOpen = true;
      return;
    }

    foldableButton = true;
    foldableOpen = false;
  };

  onMount(() => {
    manageFold();

    window.addEventListener('resize', manageFold);
  });
</script>

<div class="flex flex-col gap-8">
  <ActivityTags bind:value={filterTags.current} />

  {#if foldableButton && !foldableOpen}
    <button
      type="button"
      class="btn-underline-black"
      onclick={() => (foldableOpen = true)}
    >
      <Svg
        image="filters"
        width={24}
        height={24}
        className="2xl:fluid-w-[24] 2xl:fluid-h-[24]"
      />
      <span>Filters tonen</span>
    </button>
  {/if}

  {#if foldableOpen}
    <div in:fade class="flex flex-col gap-8">
      <FormField
        background="yellow"
        type="search"
        label="Zoeken op naam"
        id="search"
        name="search"
        placeholder="Bijv. Dikke Banden Race Alkmaar"
        bind:value={searchValue.current}
      />

      <div class="flex gap-2">
        <div class="flex-2/3">
          <FormField
            background="yellow"
            type="text"
            label="Plaats of postcode"
            id="location"
            name="location"
            placeholder="Bijv. Alkmaar"
            bind:value={locationDisplay.current}
            onBlur={handleLocationBlur}
          />
        </div>
        <div class="flex-1/3">
          <FormField
            background="yellow"
            type="select"
            label="Straal"
            id="distance"
            name="distance"
            showFirstEmptyValue={false}
            options={Object.entries(
              calendarService.FILTER_DISTANCE_OPTIONS
            ).map(([value, label]) => ({ value, label }))}
            bind:value={distanceValue.current}
          />
        </div>
      </div>

      <FormField
        background="yellow"
        type="date"
        id="date"
        name="date"
        label="Datum"
        placeholder="Selecteer een datum"
        attributes={{
          dateObjects: dateObjects.current,
        }}
        bind:value={dateObjects.current}
      />

      {#if foldableButton}
        <button
          type="button"
          class="btn-underline-black"
          onclick={() => (foldableOpen = false)}
        >
          <Svg
            image="cross-normal"
            width={24}
            height={24}
            className="2xl:fluid-w-[24] 2xl:fluid-h-[24]"
          />
          <span>Filters verbergen</span>
        </button>
      {/if}
    </div>
  {/if}
</div>
